'use client';

import * as SheetPrimitive from '@radix-ui/react-dialog';
import { type ComponentPropsWithoutRef, type ElementRef, forwardRef } from 'react';

import { cn } from '../../lib/utils';

interface SheetOverlayProps extends ComponentPropsWithoutRef<typeof SheetPrimitive.Overlay> {
  hasBackdrop: boolean;
}

const overlayStyles = `
  r:fixed r:inset-0 r:z-overlay-background
  r:data-[state=open]:animate-in
  r:data-[state=closed]:animate-out
  r:data-[state=closed]:fade-out-0
  r:data-[state=open]:fade-in-0
`;

const SheetOverlay = forwardRef<ElementRef<typeof SheetPrimitive.Overlay>, SheetOverlayProps>(
  ({ hasBackdrop, className, ...props }, ref) => (
    <SheetPrimitive.Overlay
      className={cn(
        'rds-sheet-overlay',
        overlayStyles,
        hasBackdrop && 'r:[--overlay:theme(sheetOverlay.bg.default)] r:bg-(--overlay) r:opacity-20',
        className
      )}
      data-sds-id="sheet-overlay"
      {...props}
      ref={ref}
    />
  )
);
SheetOverlay.displayName = SheetPrimitive.Overlay.displayName;

export { overlayStyles, SheetOverlay };
